module.exports = require("class-validator");


//////////////////
// WEBPACK FOOTER
// external "class-validator"
// module id = 6
// module chunks = 0